import { render, staticRenderFns } from "./AirSideDetails.vue?vue&type=template&id=eb04c1c0&"
import script from "./AirSideDetails.vue?vue&type=script&lang=js&"
export * from "./AirSideDetails.vue?vue&type=script&lang=js&"
import style0 from "./AirSideDetails.vue?vue&type=style&index=0&id=eb04c1c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports